export default __webpack_public_path__ + "static/media/Pit Fighter's Clawed Cord.e6146394.jpg";